import { render, staticRenderFns } from "./Article.vue?vue&type=template&id=3747dd52&"
import script from "../../model/article.js?vue&type=script&lang=js&"
export * from "../../model/article.js?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports